export let BoxInputState = /*#__PURE__*/function (BoxInputState) {
  BoxInputState["Success"] = "success";
  BoxInputState["Error"] = "error";
  BoxInputState["Default"] = "default";
  return BoxInputState;
}({});